
import getAuthService from "@/services/AuthService";
import Loader from "@/components/Loader.vue";
import RGPDLink from "@/components/RGPDLink.vue";
import GcuLink from "@/components/gcuLink.vue";
export default {
    name: "ForgetPassword",
    components: {
        Loader,
        GcuLink,
        RGPDLink
    },
    data() {
        return {
            email: "",
            isPending: false,
            successMessage: "",
            error: "",
            timer: null as null | number
        };
    },
    computed: {
        formInvalid() {
            return this.email.length < 3;
        }
    },
    beforeUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    },
    methods: {
        async submitForm() {
            this.error = "";
            this.isPending = true;
            try {
                await getAuthService().forgetPassword(this.email);
                this.isPending = false;
                this.successMessage = this.$t("signInUp.forgetPasswordSuccess");
                this.timer = setTimeout(() => this.$router.replace("SignIn"), 3000);
            } catch (e) {
                this.isPending = false;
                this.error = this.$t("errorsUid." + (e.response?.data?.uid || e.code || e.message));
            }
        },

        validateEmail(ev: Event) {
            const input = ev.target as HTMLInputElement;
            input.value = input.value.toLowerCase();
        }
    }
};
